import React, { useEffect, useState } from "react";
import svg82 from "../assets/svg/svg82.svg";
import svg83 from "../assets/svg/svg83.svg";
import svg84 from "../assets/svg/svg84.svg";
import { Breadcrumb, Dropdown, Menu, Input } from "antd";
import { useDispatch, useSelector } from "react-redux";
import axiosInstance from "../instance";
import { fetchCounties, fetchData } from "../features/fetch/fetchSlice";
import { useNavigate } from "react-router-dom";

const HeaderCrumb = () => {
  const url ='auth/counties/getFiltered'
  const navigate = useNavigate();
  const [selectedOrg, setSelectedOrg] = useState(
    localStorage.getItem("selectedOrg")
  );
  const [selectedCounty, setSelectedCounty] = useState(
    localStorage.getItem("selectedCounty")
  );

  const [searchValue, setSearchValue] = useState("");
  const { counties } = useSelector((state) => state.fetch);
  const dispatch = useDispatch();
  const [data, setData] = useState([]);

  const handleOrgClick = async ({ key }) => {
    await localStorage.setItem("selectedOrg", key);
    await localStorage.removeItem("selectedCounty");
    await setSelectedOrg(key);
    await setSelectedCounty(null);
    await navigate("/dashboard-main");
  };

  const handleCountyClick = async (item) => {  
    localStorage.setItem("selectedCounty", item?.usrType);
    setSelectedCounty(item?.usrType);
    fetchTableData(item?.usrCountyId);
    await navigate("/dashboard-main");
  };

  const orgMenu = (
    <Menu onClick={handleOrgClick}>
      <Menu.Item key="NWHSA">NWHSA</Menu.Item>
      <Menu.Item key="COUNTY">COUNTY</Menu.Item>
      <Menu.Item key="NIA">NIA</Menu.Item>
    </Menu>
  );

  const filteredCounties = data?.filter((county) =>
    county?.usrCountyName?.toLowerCase()?.includes(searchValue?.toLowerCase())
  );
 

  const countyMenu = (
    <Menu>
      <Menu.Item key="search" disabled>
        <Input
          placeholder="Search county"
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
        />
      </Menu.Item>
      <Menu.Divider />
      <div style={{ maxHeight: "250px", overflowY: "auto" }}>
        {filteredCounties?.length > 0 ? (
          filteredCounties?.map((county) => (
            <Menu.Item
              key={county?.usrId}
              onClick={() => handleCountyClick(county)}
            >
              {county?.usrType}
            </Menu.Item>
          ))
        ) : (
          <Menu.Item disabled>No results found</Menu.Item>
        )}
      </div>
    </Menu>
  );

  
   async function fetchTableData(id) {
      await dispatch(
        fetchData({
          url: url,
          countyId: id, 
          start:0,
          limit:null,
        })
      );
    }
  

  async function fetchCountyHeaderData() {
    try {
      const res = await axiosInstance.post(
        "https://dev.nisip.co.ke/api/v2/cidu/get",
        {
          start: 0,
          limit: null,
        }
      );
      setData(res?.data?.data?.result);
    } catch (err) {
      console.error("Error fetching county header data:", err);
    }
  }

  const handleRemove = async () => {
    localStorage.removeItem("selectedCounty");
    localStorage.removeItem("selectedOrg");
    setSelectedOrg(null);
    setSelectedCounty(null);
    await navigate("/dashboard-main");
  };
  return (
    <div>
      <Breadcrumb separator={<img src={svg83} alt="separator" />}>
        <Breadcrumb.Item>
          <span
            className="flex items-center cursor-pointer"
            onClick={handleRemove}
          >
            <img className="mr-[.5rem]" src={svg82} alt="svg82" />
            IRRIGATION INST.
          </span>
        </Breadcrumb.Item>

        <Breadcrumb.Item>
          <Dropdown overlay={orgMenu} trigger={["click"]}>
            <span className="flex items-center cursor-pointer">
              <img className="mr-[.5rem]" src={svg82} alt="svg82" />
              {selectedOrg ? selectedOrg : "SELECT"}
              <img src={svg84} alt="icon" className="ml-1" />
            </span>
          </Dropdown>
        </Breadcrumb.Item>

        {selectedOrg === "COUNTY" && (
          <Breadcrumb.Item>
            <Dropdown
              overlay={countyMenu}
              trigger={["click"]}
              onVisibleChange={(visible) => {
                if (visible) {
                  fetchCountyHeaderData();
                }
              }}
            >
              <span className="flex items-center cursor-pointer">
                <img className="mr-[.5rem]" src={svg82} alt="svg82" />
                {selectedCounty ? selectedCounty : "SELECT"}
                <img src={svg84} alt="icon" className="ml-1" />
              </span>
            </Dropdown>
          </Breadcrumb.Item>
        )}
      </Breadcrumb>
    </div>
  );
};

export default HeaderCrumb;
